import size from 'lodash/size';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import css from './css.css';

import { getDialogModelId, getField, getItemId, getValueAdaptData, getValueAdaptSources } from '~/stateGetter';
import { mergeField, presentConstraintValues, reduceFieldSources } from '~/statePresenter';

import identify from '~/identify';
import { connect } from '~/redux/connect';
import { compareKeys, diffKeys } from 'mythil/object';
import { fetchFieldOptions } from '~/rx/model/fieldOptions';
import { modelActionsCreator } from '~/actions/model_actions';

let emptyObject = {};

const _areStatePropsEqual = (prev, curr) => {
    return compareKeys(prev, curr, {
        compareFoo: (a, b, key) => {
            switch (key) {
                case 'valueAdaptSources':
                    return isEqual(a, b);
                case 'constraintValues':
                    return isEqual(a, b);
                default:
                    return a === b;
            }
        },
    });
};

const areStatePropsEqual = (prev, curr) => {
    let isEqual = _areStatePropsEqual(prev, curr);

    if (!isEqual) {
        // console.log('VARIADIC FIELD areStatePropsEqual "'+curr.field.name+'"  PERF', diffKeys(prev, curr));
    }

    return isEqual;
};

// TODO: think of concept where you can avoid this mess
export const connectedField = connect(
    (state, { modelId, name, inputType, ...others }) => {
        let fieldData = others.fieldData || getField(state, modelId, inputType, name),
            small = getDialogModelId(state) === modelId;

        let props = {
            ...fieldData,
            itemId: getItemId(state, modelId),
            small,
        };

        if (fieldData.field.adaptValue || size(fieldData.field.constraints)) {
            props = { ...props, ...getValueAdaptData(state, modelId) };
            props.valueAdaptSources = getValueAdaptSources(state, modelId);
            props.valueAdaptSources = reduceFieldSources(
                fieldData.field,
                props.editFields,
                props.filters,
                props.valueAdaptSources
            );
        }

        return props;
    },
    (dispatch, { modelId, name, inputType }) => {
        const modelActions = modelActionsCreator(modelId);

        return {
            dispatch,
            onChange: (value, filterType = '') =>
                dispatch(modelActions.changeFieldValue(name, inputType, value, { filterType })),
            onQueryChange: (query) => dispatch(modelActions.changeFieldQuery(name, inputType, query)),
        };
    },
    (
        { className, field, valueAdaptSources, validationMessage, ...other },
        { dispatch, ...otherActions },
        { modelId, view, ...ownProps }
    ) => {
        className = cn(className, { [css.validationError]: !!validationMessage });

        let mergeData = { field, ...other, ...valueAdaptSources };

        let constraintValues = emptyObject;
        if (size(field.constraints)) {
            constraintValues = presentConstraintValues(field.inputType, field.constraints, {
                ...other,
                ...valueAdaptSources,
            });
        }
        const mergedFields = mergeField(mergeData);
        let fieldData = {
            ...ownProps,
            modelId,
            constraintValues,
            ...other,
            ...otherActions,
            ...mergeField(mergeData),
            onChange: ownProps.onChange || otherActions.onChange,
            requestGroup: field.isAutocomplete
                ? identify.modelFieldRequestGroup(modelId, field.inputType, field.name)
                : undefined,
            isinvalid: !!validationMessage?.length,
            isReadonly: view === identify.VIEW_VIEW || ownProps.isReadonly || !field.editable || field.disable_input,
            title: ownProps.title ?? field.title,
            validationMessage: validationMessage?.length ? validationMessage : null,
            className,
            fetchOptions: (query, selectedItems) => {
                return dispatch(
                    fetchFieldOptions(modelId, field.inputType, {
                        field: field.name,
                        selectedItems: selectedItems,
                        page: 1,
                        term: query,
                    })
                );
            },
        };

        return fieldData;
    },
    { areStatePropsEqual, forwardRef: true }
);
